import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = get(state, 'micYear.year');
  const imgPresets =
    'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';

  return baseSeoUtil({
    site,
    siteConf,
    title: `The ${year} World's Most Innovative Companies`,
    url: `https://www.fastcompany.com/most-innovative-companies/${year}`,
    description: `Our annual guide to the businesses that matter the most`,
    image: `${imgPresets}/v1495030888/fcweb/MIC-${year}-Logo-OG.png`,
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
}
